var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"pt-md-6",style:({ paddingBottom: _vm.$vuetify.breakpoint.mdAndUp ? '60px' : '200px' }),attrs:{"align":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"6","offset-md":"1"}},[_c('Calculator')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }